const basePath = '/metabase-reports'

const routes = {
  root: basePath,
  list: () => basePath,
  report: (reportUid: string) => `/metabase-reports/${reportUid}`,
}

export default routes
